import { createContext } from "react"

//? 1-) Login context'nin olusturulması (creating)
export const LoginContext = createContext()
